import { TextInput, SelectInput } from 'react-admin';
import { cms1500JobsFields } from '../../cms1500Jobs.model';
import React from "react";
import PeriodInput from "../../../app/periodInput.component";

const cms1500JobStatuses = [
    { id: 'SUCCESS', name: 'SUCCESS' },
    { id: 'FAILED_TERMINAL', name: 'FAILED_TERMINAL' },
    { id: 'FAILED_DATA_EXTRACTION', name: 'FAILED_DATA_EXTRACTION' },
    { id: 'PENDING', name: 'PENDING' },
    { id: 'PROCESSING', name: 'PROCESSING' },
    { id: 'FAILED_RETRYABLE', name: 'FAILED_RETRYABLE' },
    { id: 'SKIPPED_APPOINTMENT_STATUS', name: 'SKIPPED_APPOINTMENT_STATUS' },
    { id: 'SKIPPED_NO_PRIMARY_INSURANCE', name: 'SKIPPED_NO_PRIMARY_INSURANCE' },
    { id: 'SKIPPED_NON_FFS_GROUP', name: 'SKIPPED_NON_FFS_GROUP' },
    { id: 'SKIPPED_LACTATION_RESTRICTION', name: 'SKIPPED_LACTATION_RESTRICTION' },
    { id: 'SKIPPED_ALREADY_EXISTS', name: 'SKIPPED_ALREADY_EXISTS' },
    { id: 'SKIPPED_HOTLINE', name: 'SKIPPED_HOTLINE' }
];

export const Cms1500JobsFilters = [
    <TextInput source={cms1500JobsFields.patientId} label="Patient ID" alwaysOn />,
    <TextInput source={cms1500JobsFields.appointmentId} label="Appointment ID" />,
    <TextInput source={cms1500JobsFields.formAnswerGroupId} label="Chart Note ID" />,
    <TextInput source={cms1500JobsFields.healthieCms1500Id} label="Healthie CMS1500 ID" />,
    <SelectInput
        key="status"
        label="Status"
        source={cms1500JobsFields.status}
        choices={cms1500JobStatuses}
        alwaysOn
    />,
    <PeriodInput
        source="createdBetween"
        fromLabel="Created At From"
        toLabel="Created At To"
        label="Created At"
    />,
];
